import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
/*::
import type { Node } from 'react';

export type IconProps = {|
  color?: string,
  width?: number,
  height?: number,
|}
*/

var WDZ = 97.637;
var HGT = 97.637;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var Twitter = function Twitter(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1B4473' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "width", "height"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;
  /* eslint-disable max-len */

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 " + WDZ + " " + HGT,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem"
    }
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M97.523,18.526c-0.14-0.165-0.371-0.221-0.568-0.131c-2.919,1.295-5.99,2.226-9.153,2.776 c3.358-2.526,5.86-6.024,7.143-10.035c0.062-0.192-0.002-0.402-0.159-0.527c-0.158-0.125-0.377-0.141-0.55-0.038 c-3.782,2.243-7.878,3.824-12.18,4.701c-3.812-3.956-9.135-6.219-14.644-6.219c-11.204,0-20.318,9.114-20.318,20.317 c0,1.355,0.131,2.697,0.391,4c-15.518-0.958-30.028-8.408-39.894-20.509c-0.101-0.124-0.254-0.193-0.414-0.177 c-0.159,0.012-0.301,0.102-0.381,0.239c-1.8,3.088-2.751,6.621-2.751,10.215c0,6.229,2.83,12.053,7.649,15.896 c-2.481-0.298-4.904-1.079-7.089-2.292c-0.147-0.083-0.33-0.082-0.477,0.003c-0.147,0.084-0.24,0.24-0.244,0.41l-0.002,0.26 c0,8.946,5.895,16.801,14.282,19.409c-2.209,0.356-4.501,0.332-6.754-0.098c-0.166-0.031-0.34,0.026-0.454,0.154 c-0.113,0.128-0.151,0.307-0.099,0.469c2.515,7.85,9.503,13.355,17.637,14.041c-6.785,4.971-14.805,7.59-23.279,7.59 c-1.561,0-3.133-0.093-4.673-0.274c-0.22-0.025-0.438,0.106-0.514,0.317c-0.076,0.213,0.005,0.451,0.195,0.572 c9.17,5.881,19.773,8.988,30.664,8.988c35.625,0,56.913-28.938,56.913-56.914c0-0.779-0.015-1.554-0.046-2.327 c3.843-2.811,7.142-6.252,9.802-10.235C97.675,18.929,97.662,18.692,97.523,18.526z"
  }));
  /* eslint-enable max-len */
};

export default Twitter;